
const VP = [
      {
        page: 2,
        texteIndice: [
            "Additions",
            "32",
            "Réponse : 12"]
      },
      {
        page: 4,
        texteIndice: [
          "Arborigène : Qui vient d'Autralie",
          "Koala"
        ]
      },
      {
        page: 6,
        texteIndice: [
            "Ecris sur la façade",
            "Reclassez les lettres avec les écoles de gauche à droite",
            "Réponse: Phocéen"
        ]
      },
      {
        page: 7,
        texteIndice: [
          "Un cheval mythique à corne",
          "C'est écris dessus",
          "Réponse: Soixante-Douze (%)"
        ]
      },
      {
        page: 9,
        texteIndice: [
          "Au numéro 2",
          "Des lions et au coin la vierge",
          "Réponse : 1854"
        ]
      },
      {
        page: 11,
        texteIndice: [
          "Commencez par trouver le temple",
          "Faites comme la l'inscription",
          "Réponse : Savon"
        ]
      },
      {
        page: 12,
        texteIndice: [
          "Plaquez le carnet",
          "Trouvez la plaque dans la rue",
          "Réponse : Charpentier"
        ]
      },
      {
        page: 14,
        texteIndice: [
          "Un bistrot",
          "Que manque-t'il à son nom ?",
          "Aiguilles (il en manque !)"
        ]
      },
      {
        page: 16,
        texteIndice: [
          "La Canebière",
          "La Cane et la Bière, gardez-les",
          "Trouvez le (vrai) cadenas accroché",
          "Perseverez (gravé sur le cadenas)"
        ]
      },
      {
        page: 18,
        texteIndice: [
          "Les traits rouges sont une fausse piste",
          "Trouvez le numéro différent",
          "Réponse : 9"
        ]
      },
      {
        page: 20,
        texteIndice: [
          "Pliez, le message apparait",
          "Comptez les balcons",
          "Réponse : 8"
        ]
      },
      {
        page: 22,
        texteIndice: [
          "Ils sont fixés à la coque",
          "Réponse : 2"
        ]
      },
      {
        page: 23,
        texteIndice: [
          "Comptez les fers",
          "Les fers à cheval accrochés au mur, le grand aussi",
          "Réponse : 13"
        ]
      },
      {
        page: 25,
        texteIndice: [
          "La réponse n'est pas 12 minutes",
          "Il est ok de cuire plus tard l'autre coté",
          "Réponse : 9"
        ]
      },
      {
        page: 28,
        texteIndice: [
          "L'immeuble'",
          "Comme sont empilés les boutiques ?",
          "Réponse : bleu"
        ]
      },
      {
        page: 29,
        texteIndice: [
          "Regardez la belle vue",
          "Il manque quelque chose à l'horizon",
          "Réponse : Aïoli"
        ]
      },
      {
        page: 99,
        lib_page: "Dernière étape - Vérifier la réponse à toute l'enquête !",
        lib: "Vous avez terminé le parcours ? Bravo ! Alors que donne l'enquête ?",
        lib_win_title: "Bravo ! Félicitations !",
        lib_win_texte: "Encore un grand merci d'avoir participé à l'un de nos jeux !",
        questions: ["Quel est le numéro du coupable ?", "Avec combien de mots raturés ?"],
        answers: [4,6]
      }
    ];

export default VP;